"use client";
import type { GameData } from "@/app/games/(details)/types";
import { Action } from "@/context/AnalyticsProvider";
import { useGamePageOldAnalytics } from "@/context/AnalyticsProvider/gamePageOld";
import { useEffect } from "react";
import ReactPlayer from "react-player-v3";
import { GamePageModal } from "../GamePageModal";

interface VideoModalProps {
  isModalOpen: boolean;
  handleOpenChange: (open: boolean) => void;
  gameData: GameData;
}

export const VideoModal = ({
  isModalOpen,
  handleOpenChange,
  gameData,
}: VideoModalProps) => {
  const { track } = useGamePageOldAnalytics();

  useEffect(() => {
    if (isModalOpen && gameData.details.game_id) {
      track({
        action: Action.VIEWED,
        extras: {
          id: "video-modal",
          gameId: gameData.details.game_id,
          gameName: gameData.details.name,
          version: "v3",
        },
      });
    }
  }, [isModalOpen, gameData.details.game_id, gameData.details.name, track]);

  return (
    <GamePageModal
      title={`${gameData.details.name} Official Trailer`}
      gameTitle={gameData.details.name}
      gameIcon={gameData.details.logo_url}
      isModalOpen={isModalOpen}
      setIsModalOpen={handleOpenChange}
      gameId={gameData.details.game_id}
      className="h-[95%] sm:h-[90%] top-[52.5%] sm:top-1/2 before:rounded-b-none [&>div]:rounded-b-none sm:before:rounded-b-[1.25rem] sm:[&>div]:rounded-b-[1.25rem]"
    >
      <ReactPlayer
        src={gameData.gameContent?.trailer_url}
        autoPlay={isModalOpen}
        controls
        loop
        width="100%"
        height="100%"
        playsInline
        className="relative h-full w-full mx-auto rounded-b-none sm:rounded-b-[1.25rem] overflow-hidden cursor-pointer"
      />
    </GamePageModal>
  );
};
